// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__9bEA+","socialContacts":"Contacts_socialContacts__OSh1b"};